/* Ramair — Convermax search-result cart bridge for the native Horizon drawer.
 * TARGET: assets/convermax-custom.js
 * Replace this asset's entire contents with this file.
 * Load with defer, paired with the synchronous fitment bootstrap in theme.liquid.
 * Do not load the old combined asset alongside this replacement.
 * Preserve existing Convermax CSS and normal PDP forms.
 * Theme-owned native APIs must be rechecked after theme upgrades.
 * Local tests are not a deployed/live-cart verification.
 */
(function () {
  'use strict';

  if (window.__ramairConvermaxCartLoaded) return;
  window.__ramairConvermaxCartLoaded = true;

  // Fitment settings run in the inline head bootstrap, before vendor boot.
  async function setupCart() {
    var modules = await Promise.all([
      import('@shopify/events'),
      import('@theme/section-renderer')
    ]);
    var CartLinesUpdateEvent = modules[0].CartLinesUpdateEvent;
    var renderer = modules[1];
    var pendingForms = new WeakSet();
    var cartQueue = Promise.resolve();

    document.addEventListener('submit', async function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) ||
          !form.matches('.cm_product-item__buttons-form')) return;
      var action = new URL(form.action, window.location.href);
      if (form.method.toLowerCase() !== 'post' || action.origin !== window.location.origin ||
          !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) return;
      var drawer = document.querySelector('cart-drawer-component');
      var drawerHost = drawer && drawer.closest('theme-drawer');
      var cartItems = drawer && drawer.querySelector('cart-items-component[data-section-id]');
      var sectionId = cartItems && cartItems.dataset.sectionId;
      if (!drawerHost || typeof drawerHost.open !== 'function' || !sectionId ||
          !document.getElementById('shopify-section-' + sectionId)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (pendingForms.has(form)) return;
      pendingForms.add(form);
      var data = new FormData(form);
      var button = event.submitter;
      if (button) button.disabled = true;
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      data.set('sections', sectionId);
      data.set('sections_url', window.location.pathname);
      // Snapshot each clicked form now, but serialize requests and drawer hydration.
      var previousUpdate = cartQueue;
      var releaseQueue;
      cartQueue = new Promise(function (resolve) { releaseQueue = resolve; });
      await previousUpdate;
      var confirmedAdded = false;
      try {
        var response = await fetch(root + 'cart/add.js', {
          method: 'POST', body: data, credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        var added = await response.json();
        if (!response.ok || added.status) {
          window.alert(typeof added.description === 'string' ? added.description : 'This item could not be added to your cart.');
          return;
        }
        confirmedAdded = true;
        var cartResponse = await fetch(root + 'cart.js', {
          credentials: 'same-origin', headers: { Accept: 'application/json' },
          cache: 'no-store'
        });
        if (!cartResponse.ok) throw new Error('Could not read the updated cart.');
        var cart = await cartResponse.json();
        // Hydrate first: do not open a drawer containing stale/empty cart markup.
        var sectionHTML = added.sections && added.sections[sectionId];
        try {
          if (typeof sectionHTML !== 'string' || !sectionHTML.trim()) throw new Error('Cart section HTML missing.');
          await renderer.morphSection(sectionId, sectionHTML, { mode: 'hydration', injectStylesheet: true });
        } catch (refreshError) {
          // Section rendering may return null after a successful add. Refresh, never add again.
          await renderer.sectionRenderer.renderSection(sectionId, { cache: false, mode: 'hydration', injectStylesheet: true });
        }
        document.dispatchEvent(new CartLinesUpdateEvent({
          action: 'add', source: 'ramair-convermax',
          lines: [{ merchandiseId: data.get('id'), quantity: Number(data.get('quantity') || 1) }],
          promise: Promise.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: { sections: added.sections }
          })
        }));
      } catch (error) {
        console.warn('[Ramair Convermax] Cart update could not be confirmed.', error);
        // Never resubmit after a network error: the server may already have added it.
        window.alert(confirmedAdded
          ? 'The item was added, but the cart drawer could not refresh. Please check your cart at ' + root + 'cart before adding it again.'
          : 'We could not confirm the cart update. Please check your cart before trying again.');
      } finally {
        releaseQueue();
        pendingForms.delete(form);
        if (button) button.disabled = false;
      }
    }, true);
  }

  function startCart() {
    setupCart().catch(function (error) {
      // Unsupported/changed theme: retain the original Convermax form behaviour.
      console.warn('[Ramair Convermax] Horizon cart bridge unavailable.', error);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCart, { once: true });
  } else {
    startCart();
  }
})();
